import React, {useState, useContext, useEffect} from 'react';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {createOtp, validateOtp, checkNiudCodeRequirement} from '../SimActivationProviders';
import SimInput, {SimInputChange} from './SimInput';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';
import {getRecaptchaToken} from 'app/utilities/recaptcha/recaptcha';
import {dwhPortingOtpPageButtonClick, dwhPortingOtpPageDisplayed} from '../reports/dwhReports';

function SimVerifyCode(props) {
  const [{phone, ticket, stage}, dispatch] = useContext(SimActivationContext);
  const [input, setInput] = useState<SimInputChange>(null);
  const [failed, setFailed] = useState<boolean>(false);

  useEffect(() => {
    dwhPortingOtpPageDisplayed({subscriber: phone ?? '', userDetails: props.userDetails});
  }, []);

  async function sendAgain(sendTextAsVoice: boolean) {
    const captchaToken = await getRecaptchaToken('SimVerifyPhone');
    if (!captchaToken) return;
    props.showAppLoader();
    const phoneNumber = phone;
    const result = await createOtp({phoneNumber, sendTextAsVoice, captchaToken});
    result && dispatch({type: 'ticket', ticket: result, phone});
    props.hideAppLoader();
  }

  async function onContinue() {
    dwhPortingOtpPageButtonClick({subscriber: phone ?? '', userDetails: props.userDetails});
    if (input?.valid) {
      props.showAppLoader();
      const phoneNumber = phone;
      const otpCode = input.value;
      setFailed(false);
      const result = await validateOtp({phoneNumber, ticket, otpCode});
      if (!result) {
        input.reset();
        setFailed(true);
      } else {
        var res = dispatch({type: 'code', value: result});
      }
      props.hideAppLoader();
    }
  }

  return (
    <div className='SimVerifyCode'>
      <h1 className='SimActivationBlock__main__title'>הפעלת ניוד</h1>
      <h1 className='SimActivationBlock__top__title'>קיבלת קוד אימות ב-SMS?</h1>
      <p className='SimActivationBlock__top__link'>הקלידו את הקוד ששלחנו בהודעה</p>

      <SimInput digits={6} onChange={setInput} />

      {failed && <div className='SimActivationBlock__failed'>הקוד שגוי, נסה שנית</div>}

      <div className='SimVerifyCode__send'>
        <div className='SimVerifyCode__item' onClick={() => sendAgain(false)}>
          {/* <img src={require('../images/icons-sms.svg')} /> */}
          <div>לא קיבלתי קוד, שילחו לי שוב</div>
        </div>
        <div className='SimVerifyCode__item' onClick={() => sendAgain(true)}>
          {/* <img src={require('../images/icons-voice.svg')} /> */}
          <div>שילחו לי קוד בהודעה קולית</div>
        </div>
      </div>

      <div className='SimActivationBlock__button'>
        <button className='btn-continue' onClick={onContinue}>
          המשך
        </button>
      </div>
    </div>
  );
}

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.authentication?.loginData?.userDetails,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimVerifyCode);
